import React, { useState } from "react";

function AdminUpdate() {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.name.endsWith('.csv')) {
            setSelectedFile(file);
        } else if (file) {
            alert("CSV 파일만 가능합니다.");
            event.target.value = "";
        }
    };

    return (
        <div className="admin-detail">
            <div className="admin-title">
                {/* label을 버튼처럼 꾸미고 input은 숨깁니다 */}
                파일 선택 :
                <label
                    htmlFor="csv-upload"
                    className="custom-file-upload"
                    style={{
                        cursor: 'pointer',
                        padding: '6px 12px',
                        backgroundColor: '#efefef',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        display: 'inline-block',
                        marginLeft: '5px'
                    }}
                >
                    첨부 파일
                </label>
                <input
                    id="csv-upload"
                    type="file"
                    accept=".csv"
                    onChange={handleFileChange}
                    style={{ display: 'none' }} /* 여기서 실제 input을 숨깁니다 */
                />
            </div>

            {/* 파일 이름은 아래에서만 제어할 수 있습니다 */}
            <p className="admin-item">
                {selectedFile ? `선택된 파일: ${selectedFile.name}` : "파일을 선택해주세요."}
            </p>
        </div>
    );
}

export default AdminUpdate;